import { Site } from '@cinch-labs/sites-sdk'
import FindASite, { FindASiteContentProps } from '@cinch-nx/find-a-site'

const onSiteCardClick = (site: Site) => {
  const slug = site.getFeatureAttribute('slug')

  if (slug && site.hasTagAttribute('webuyanycar')) {
    window.open(
      `https://www.cinch.co.uk/cars-near-me/collection-location/${slug.replace(
        /^wbac-/,
        '',
      )}`,
      '_blank',
    )
  } else {
    window.open(`https://www.cinch.co.uk/store/${slug}`, '_blank')
  }
}

export const FindASiteWrapper = (props: FindASiteContentProps) => (
  <FindASite
    onSiteCardClick={onSiteCardClick}
    siteQueryFilters={{ tags: ['collection-location'] }}
    content={props}
  />
)
